























import { EventBus, EventBusEvent } from '@front-app/services/EventBus';
import { useDiscussionStore } from '@front-app/store/piniaModules/discussions';
import { UploadsStore } from '@front-app/store/singletons/UploadsStore';
import {
	defineComponent,
	PropType,
	ref,
} from '@vue/composition-api';
import { FileData } from './FileModel';
import ShareMultiple from './ShareMultiple.vue';

export default defineComponent({
	components: {
		ShareMultiple,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		messageId: {
			type: String,
			default: '',
		},
		categories: {
			type: Array as PropType<string[]>,
			required: true,
		},
		defaultCategories: {
			type: Array as PropType<string[]>,
			required: true,
		},
		maxUploadFileSize: {
			type: Number,
			default: Infinity,
		},
		remainingTotalFileBytes: {
			type: Number,
			default: Infinity,
		},
		canNotifyMembers: Boolean,
		notifyMembersDefault: Boolean,
		canAddNewCategories: Boolean,
	},
	setup(props, ctx) {
		const discussionStore = useDiscussionStore();
		const selectedCategories = ref([...props.defaultCategories]);
		const selectedNewCategories = ref([]);
		const removeCategory = (cat: string) => {
			selectedCategories.value = selectedCategories.value.filter((current) => current !== cat);
		};
		const removeNewCategory = (cat: string) => {
			selectedNewCategories.value = selectedNewCategories.value.filter((current) => current !== cat);
		};
		const notifyGroup = ref(props.notifyMembersDefault || false);
		const uploadFiles = async (files: FileData[]) => {
			const category = ([] as string[]).concat(selectedCategories.value)
				.concat(selectedNewCategories.value);
			const notify = notifyGroup.value;
			ctx.emit('uploads-started');
			await Promise.all(files.map(({ file, fileName, description }) => UploadsStore.upload({
				groupId: props.groupId,
				messageId: props.messageId,
				category,
				notify,
				file,
				fileName,
				description,
			})));
			EventBus.emit(EventBusEvent.FILES_UPLOADED);
			// Refresh discussion thread if uploading file(s) to it
			if (props.messageId) {
				discussionStore.fetch(props.groupId, props.messageId);
			}
		};
		return {
			uploadFiles,
			notifyGroup,
			// Categories
			selectedCategories,
			selectedNewCategories,
			removeCategory,
			removeNewCategory,
		};
	},
});
